import { render } from "./CheckBoxComponent.vue?vue&type=template&id=538fe5f4"
import script from "./CheckBoxComponent.vue?vue&type=script&lang=js"
export * from "./CheckBoxComponent.vue?vue&type=script&lang=js"

import "./CheckBoxComponent.vue?vue&type=style&index=0&id=538fe5f4&lang=scss"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__